import currency from "currency.js";
import { ethers } from "ethers";

import { DepositWithdrawCollaterals } from "../../constants/addresses";
import { ChainIdEnum } from "../../enums/chain";
import { ID_TO_CHAINS } from "../../hooks/wallet/useWallet";
import { IDepositERC20MultichainResponse } from "../../hooks/contracts/useDeposit";
import { supportedSigningChainIds } from "../../utils/wallet/connectors";
import { ConnectWalletPageEnum, ConnectWalletPageHeightType } from "./types";

export const ConnectWalletPageHeights: ConnectWalletPageHeightType = {
  [ConnectWalletPageEnum.ONBOARD]: "240px",
  [ConnectWalletPageEnum.CONNECT_WALLET]: "240px",
  [ConnectWalletPageEnum.SWITCH_NETWORK]: "320px",
  [ConnectWalletPageEnum.ENABLE_TRADING_SIGN]: "340px",
  [ConnectWalletPageEnum.DEPOSIT]: "300px",
};

export const pageWidth = 311;

// Extracted verbatim from the deposit handler's local `insufficientLimit`
// closure. Behaviour is unchanged; the closed-over values are passed in.
export const insufficientLimitImpl = (
  response: IDepositERC20MultichainResponse,
  {
    chainId,
    t,
    decimals,
    assetToDeposit,
    setDepositError,
  }: {
    chainId: number | undefined;
    t: (key: string, options?: any) => string;
    decimals: number;
    assetToDeposit: DepositWithdrawCollaterals;
    setDepositError: (value: string) => void;
  }
) => {
  const chainEnum = chainId as ChainIdEnum;
  const otherNetworks = supportedSigningChainIds
    .filter((c) => c !== chainEnum)
    .map((c) => ID_TO_CHAINS[c]);
  const otherNetworksText =
    otherNetworks.length === 2
      ? otherNetworks.join(` ${t("or")} `)
      : otherNetworks.join(", ");
  const currentNetworkName = ID_TO_CHAINS[chainEnum];

  // No limit
  if (response.insufficientLimit?.isZero()) {
    setDepositError(
      t("no_bridge_capacity", {
        currentChain: currentNetworkName,
        otherChains: otherNetworksText,
      })
    );
  } else {
    const limitStr = ethers.utils.formatUnits(
      response.insufficientLimit ?? "0",
      decimals
    );
    let text = t("insufficient_bridge_capacity", {
      chain: ID_TO_CHAINS[chainEnum],
    });
    text += t("reduce_deposit_size", {
      size: `${currency(limitStr).format({
        symbol: "",
      })} ${assetToDeposit}`,
      otherChains: otherNetworksText,
    });
    setDepositError(text);
  }
};
